import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Link as RouterLink } from "react-router-dom";
import { isActivePath } from "../utils/browser";
import { isInternalUrl, toInternalPath } from "../utils/internalUrl";
import { config } from "../config";
const page = 'page';
export const Link = (props)=>{
    var _props_url_match;
    // By default AanZet uses the class "link" for all links. However, when applying this to the other
    // libraries, this triggers all kinds of styling that is not wanted. The `defaultClassName` prop allows
    // us to override this default class name for other libraries.
    const isActive = !props.external && isActivePath(props.url);
    const className = `${config().defaultLinkClass} ${props.className ? props.className : ""}`;
    const onClick = (e)=>props.handle && props.handle(e);
    if (!props.url) return /*#__PURE__*/ _jsx("div", {
        className: className,
        children: props.children
    });
    const commonProps = {
        className,
        onClick,
        title: props.title,
        'aria-current': props["aria-current"] || isActive ? page : undefined,
        onBlur: props.onBlur
    };
    if ((props.url.substring(0, 4) === "http" || props.external) && !isInternalUrl(props.url)) {
        return /*#__PURE__*/ _jsx("a", {
            href: decodeUrl(props.url),
            target: "_blank",
            rel: "noopener noreferrer",
            ...commonProps,
            children: props.children
        });
    }
    // Non-HTTP URI schemes (mailto:, tel:, sms:, …) and fragment links must not
    // be passed to RouterLink, which would treat them as SPA routes.
    const scheme = (_props_url_match = props.url.match(/^([a-z][a-z0-9+.-]*):/i)) === null || _props_url_match === void 0 ? void 0 : _props_url_match[1].toLowerCase();
    // Block javascript: URLs to prevent XSS from CMS-authored content.
    if (scheme === 'javascript') {
        console.error("Javascript scheme detected while rendering a link. Please check the origin of the url.");
        return /*#__PURE__*/ _jsx("div", {
            className: className,
            children: props.children
        });
    }
    if (scheme || props.url.startsWith('#')) {
        const newTab = scheme === 'mailto' ? {
            target: '_blank',
            rel: 'noopener noreferrer'
        } : {};
        return /*#__PURE__*/ _jsx("a", {
            href: props.url,
            ...newTab,
            ...commonProps,
            children: props.children
        });
    }
    const internalPath = toInternalPath(props.url);
    return /*#__PURE__*/ _jsx(RouterLink, {
        to: internalPath,
        ...commonProps,
        children: props.children
    });
};
const decodeUrl = (url)=>{
    const parser = document.createElement("a");
    parser.href = url;
    return `${parser.origin}${parser.pathname}${parser.search}`;
};
